(() => {
  const init = () => {
    const root = document.querySelector('.ksos');
    if (!root || root.dataset.ctaReady === '1') return;
    const sticky = document.querySelector('.ksos__sticky');
    const primary = document.querySelector('#_rsi-buy-now-button._rsi-buy-now-button-product');
    if (!primary) return setTimeout(init, 300);
    root.dataset.ctaReady = '1';
    const updateSticky = () => {
      if (!sticky) return;
      const r = primary.getBoundingClientRect();
      sticky.classList.toggle('is-visible', window.innerWidth < 750 && r.bottom < 0);
    };
    document.querySelectorAll('[data-kit-sos-cod]').forEach(button => {
      button.addEventListener('click', () => primary.click());
    });
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  };
  document.addEventListener('DOMContentLoaded', init);
  init();
})();
